<template>
    <div class="m-card">
        <div class="m-card__body">
            <h2>{{number}}</h2>
            <h6 class="text-muted">{{title}}</h6>
            <i :class="icon + ' text-'+getType"></i>
        </div>
        <div class="progress">
            <div :class="'progress-bar bg-'+type" style="width:70%; height:3px;"></div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['number', 'title', 'icon', 'type'],
        data() {
            return {

            }
        },
        computed: {
            getType() {
                return this.type || 'primary'
            }
        }
    }
</script>
